import React, { useEffect, useCallback } from 'react';
import { DispatchProp, useSelector, useDispatch } from 'react-redux'
import HelloEpic from '../../epics/helloEpic';
import { IRootState, UpdateDataPaths } from '../../typings/shared';
import appReducer from '../../reducers/appReducer';

type DataProps = {
    helloMsg: string,
    byeMsg: string,
    hasPublished: boolean,
    helloImg: string | null
}
type FCProps = {
    sayHello: (msg: string) => void,
    sayBye: (msg: string) => void,
    togglePublish: () => void
}
type DetailPageProps = DataProps & FCProps & DispatchProp;
const Detail: React.FC<DetailPageProps> = (props) => {

    const dispatch = useDispatch();

    const {
        helloMsg,
        byeMsg,
        hasPublished,
        helloImg
    }: DataProps = useSelector((state: IRootState) => {
        let app = state.app;
        return {
            helloMsg: app.helloMsg,
            byeMsg: app.byeMsg,
            hasPublished: app.published,
            helloImg: app.helloImg
        }
    })

    useEffect(() => {
        !helloImg && dispatch(HelloEpic.actions.doEnsureHelloImg());
    }, [helloImg, dispatch]);


    const sayHello = useCallback((msg: string) => {
        console.log('msg', msg);
        dispatch(HelloEpic.actions.doSayHello(msg));
    }, [dispatch])

    const sayBye = useCallback((msg: string) => {
        dispatch(HelloEpic.actions.doSayBye(msg))
    }, [dispatch]);

    const togglePublish = useCallback(() => {
        dispatch(appReducer.actions.getGeneralToggleAction(UpdateDataPaths.published));
    }, [dispatch]);

    return (
        <div>
            <div className="container">
                <h1 className='h1'>Detail Page</h1>
                <div className="row">
                    <div className="col">
                        <h2 className="h2"> Hello {helloMsg}</h2>
                        <input onChange={e => sayHello(e.target.value)} />
                    </div>
                    <div className="col">
                        <h2 className='h2'>Bye {byeMsg}</h2>
                        <input onChange={e => sayBye(e.target.value)} />
                    </div>
                </div>
                <br />
                <div className="row">
                    <div className="col h2">App has {hasPublished ? "" : "not "} published</div>
                    <div className="col"><button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={() => togglePublish()}>TogglePublish</button></div>
                </div>
                <hr className='my-4' />
                <div className="row">
                    <div className="col">
                        {
                            !helloImg ? 'Loading...' : <img src={helloImg || undefined} alt="" />
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Detail;
